module.exports = __webpack_public_path__ + "static/background.e16428c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/background.jpg
// module id = 97
// module chunks = 945452645994 123714094920601 169550522521280